var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTemplateOutlined = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V3C21 2.73478 20.8946 2.48043 20.7071 2.29289C20.5196 2.10536 20.2652 2 20 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22ZM5 20V4H19V20H5ZM17 6H13V10H17V6ZM11 7H7V9H11V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(-1 0 0 1 17 6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    transform: "matrix(-1 0 0 1 17 12)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    transform: "matrix(-1 0 0 1 17 16)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    transform: "matrix(-1 0 0 1 11 7)",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTemplateOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TemplateOutlined.083f8d01.svg";
export { ForwardRef as ReactComponent };